export const CTA = {
  SCHEDULE_A_CALL: 'https://calendly.com/d/dz43-q6s-z32/introductory-meeting-with-nerdwallet-wealth-partners/',
  SCHEDULE_PAGE: '/schedule',
  SCHEDULE_FORM_PAGE: '/schedule_form',
}

export const PAID_MEDIA_CALENDLY_URL =
  'https://calendly.com/d/dz43-q6s-z32/introductory-meeting-with-nerdwallet-wealth-partners'

export const IPO_STRATEGY_CALENDLY_URL = 'https://calendly.com/d/dtnd-vcc-3nc/free-ipo-strategy-session'

export const FREE_EQUITY_STRATEGY_CALENDLY_URL = 'https://calendly.com/d/dvrh-2mf-hhz/free-equity-strategy-session'

export const WEALTH_CHECK_CALENDLY_URL =
  'https://calendly.com/d/d2jb-rd3-csh/introductory-meeting-with-nerdwallet-wealth-partners'

/** /schedule loads for these Calendly events upsert an Anonymous Tracking Snapshot when inbound tracking params exist. */
export const ANONYMOUS_TRACKING_SNAPSHOT_CALENDLY_URLS: readonly string[] = [FREE_EQUITY_STRATEGY_CALENDLY_URL]

export function calendlyUsesAnonymousTrackingSnapshot(calendlyUrl: string): boolean {
  return ANONYMOUS_TRACKING_SNAPSHOT_CALENDLY_URLS.includes(calendlyUrl)
}

export const SCHEDULE_CALENDLY_URL_PARAM = 'calendly_url'

export const SCHEDULE_TRACKING_OPTIONS = {
  appendAnonymousId: true,
  appendAnonymousIdKey: 'salesforce_uuid',
} as const

export function buildScheduleRedirectUrl(calendlyUrl: string, trackingParams: Record<string, string>): string {
  const params = new URLSearchParams({ [SCHEDULE_CALENDLY_URL_PARAM]: calendlyUrl })
  Object.entries(trackingParams).forEach(([key, value]) => params.set(key, value))
  return `${CTA.SCHEDULE_PAGE}?${params.toString()}`
}
